import Vue from "vue";

const componentMap = {
};

Object.keys(componentMap).forEach(key => {
    Vue.component(key, componentMap[key]);
});



// WEBPACK FOOTER //
// ./src/components/index.js